import AccettazioneSsnEditViewPage from "./pages/AccettazioneSsnEditViewPage.vue";
import AccettazioneSsnListPage from "./pages/AccettazioneSsnListaPage.vue";
import AccettazioneSsnSchedaPazientePage from "./pages/AccettazioneSsnSchedaPazientePage.vue"
export default {
    AccettazioneSsnListPage,
    AccettazioneSsnEditViewPage,
    AccettazioneSsnSchedaPazientePage
};
